import $ from 'jquery';
import picturefill from 'picturefill';
import 'formdata-polyfill';
import './tools/svg4everybody';

// import { media } from './tools/MQ';

// Components
import * as dropdown from './components/dropdown';
import * as fileInput from './components/fileInput';
import * as floatingLabels from './components/floatingLabels';
import * as footerMenu from './components/footerMenu';
import * as mobileMenu from './components/mobileMenu';
import * as themesDropDown from './components/themesDropDown';
import * as questions from './components/questions';
import * as accordion from './components/accordion';
import * as interactiveMap from './components/interactiveMap';
import * as floatCta from './components/floatCta';
import * as switchInput from './components/switch';
import * as articleCarousel from './components/articleCarousel';
import * as testimonialsCarousel from './components/testimonialsCarousel';
import * as exampleCarousel from './components/exampleCarousel';
import * as referencesCarousel from './components/referencesCarousel';
import * as eonLifeCarousel from './components/eonLifeCarousel';
import * as relevations from './components/relevations';
import * as stickyFallback from './components/stickyFallback';
import * as categoryDrop from './components/categoryDrop';
import * as objectfitFallback from './components/objectfitFallback';
import * as tabs from './components/tabs';
import * as form from './components/form';
import * as satisfaction from './components/satisfaction';
import * as priceFilter from './components/priceFilter';
import * as invoice from './components/invoice';
import * as company from './components/company';
import * as news from './components/news';
import * as glightbox from './components/glightbox';
import * as interactiveForms from './components/interactiveForms';
import * as about from './components/about';
import * as social from './components/social';
import * as customFocusRing from './components/customFocusRing';
import * as benefitsCarousel from './components/benefitsCarousel';
import * as advantageCarousel from './components/advantageCarousel';
import * as errorPage from './components/errorPage';
import * as careers from './components/careers';
import * as recalculation from './components/recalculation';
import * as distributionRateSelector from './components/distributionRateSelector';
import * as support from './components/support';
import * as priceSticky from './components/priceSticky';
import * as cngCalculator from './components/cngCalculator';
import * as assistant3d from './components/assistant3d';
import * as scrollTo from './components/scrollTo';
import * as range from './components/range';
import * as table from './components/table';
import * as servicesFilter from './components/servicesFilter';
import * as modal from './components/modal';
import * as filter from './components/filter';
import * as heroCards from './components/heroCards';
import * as searchResults from './components/searchResults';
import * as galleryCarousel from './components/galleryCarousel';
import * as stepsCarousel from './components/stepsCarousel';
import * as formGtmHelper from './components/formGtmHelper';
import * as suggest from './components/suggest';
import * as gtmHelper from './components/gtmHelper';
import * as priceList from './components/priceList';
import * as headerSearch from './components/headerSearch';
import * as pressRelease from './components/pressRelease';
import * as ecoMapSlider from './components/ecoMapSlider';
import * as infoBar from './components/infoBar';
import * as snake from './components/snake';
import * as eonBonus from './components/eonBonus';
import * as globalForm from './components/globalForm';
import * as megaMenu from './components/megaMenu';
import * as mobileAppBar from './components/mobileAppBar';
import * as usercentrics from './components/usercentricsCookieBar';
import * as businessEnergyFilter from './components/businessEnergyFilter';
import * as tabsCarousel from './components/tabsCarousel';
import * as tooltipsWysiwyg from './components/tooltipsWysiwyg';
import * as multiFile from './components/multiFile';
import * as modalNew from './components/modalNew';

// content load components
const componentsload = [
	dropdown,
	floatingLabels,
	categoryDrop,
	themesDropDown,
	interactiveMap,
	articleCarousel,
	testimonialsCarousel,
	referencesCarousel,
	exampleCarousel,
	eonLifeCarousel,
	floatCta,
	accordion,
	fileInput,
	switchInput,
	form,
	company /*news*/,
	priceFilter,
	glightbox,
	social,
	about,
	customFocusRing,
	benefitsCarousel,
	advantageCarousel,
	errorPage,
	recalculation,
	distributionRateSelector,
	priceSticky,
	assistant3d,
	scrollTo,
	range,
	table,
	modal,
	filter,
	heroCards,
	invoice,
	stepsCarousel,
	ecoMapSlider,
	snake,
	globalForm,
	multiFile,
	modalNew,
];

// once delegated components
const components = [
	footerMenu,
	mobileMenu,
	relevations,
	stickyFallback,
	questions,
	objectfitFallback,
	tabs,
	satisfaction,
	interactiveForms,
	careers,
	support,
	cngCalculator,
	galleryCarousel,
	formGtmHelper,
	gtmHelper,
	suggest,
	priceList,
	headerSearch,
	servicesFilter,
	searchResults,
	pressRelease,
	infoBar,
	eonBonus,
	megaMenu,
	mobileAppBar,
	usercentrics,
	tabsCarousel,
	tooltipsWysiwyg,
	businessEnergyFilter,
].concat(componentsload);

window.App = {
	run() {
		// console.log(media('lgDown'));
		// console.log(media('webkit'));

		const $target = $(document);
		components.forEach((component) => component.init($target));

		$(document).on('contentload', (event) => {
			const $eventTarget = $(event.target);
			componentsload.forEach((component) => component.init($eventTarget));
		});
	},

	initComponent(component) {
		return component.init();
	},
};
